export default function selectToURL(selector) {
    document.querySelectorAll(selector).forEach((el) => {
        el.addEventListener('change', (e) => {
           document.location.href = el.value;
        });
    })
}
